export default __webpack_public_path__ + "static/benifitImg-b418c58b57981a8aaee4474ed362f30a.png";